<template>
  <div class="agents-charts-wrapper">
    <ulu-devices-sold-details-agents-chart />
  </div>
</template>

<script>
export default {
  components: {
    "ulu-devices-sold-details-agents-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsAgentsChart"),
  }
};
</script>

<style scoped>
.agents-charts-wrapper {
  background-color: transparent;
}
</style>
